import React from 'react';
import { Danger } from 'src/assets/dynamicSvg';
import { Poppins, Spacer } from 'src/common';
import styled from 'styled-components';
import { AssessmentState } from '../types';
import { getStateWarningMessage } from '../util';
import Button from 'src/components/form/Button';
import { Link } from 'react-router-dom';

const Div = styled.div`
  height: 68px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 24px;

  .msg {
    display: flex;
    align-items: center;
    gap: 14px;
  }
`;

interface BannerProps {
  state: AssessmentState;
  assessmentId: string;
}

const renderStates: AssessmentState[] = ['NO_SCENARIOS', 'SCENARIOS_NO_CONTROLS', 'SCENARIOS_CONTROLS_NO_MODIFIERS'];

export const Banner: React.FC<BannerProps> = ({ state, assessmentId }) => {
  if (!renderStates.includes(state)) return <Spacer $px={30} />;

  return (
    <>
      <Spacer $px={20} />
      <Div>
        <div className="msg">
          <Danger />
          <Poppins px={14} weight={500}>
            {getStateWarningMessage(state)}
          </Poppins>
        </div>

        {state === 'NO_SCENARIOS' && (
          <Link to={`/risk-assessments/${assessmentId}`}>
            <Button primary>+ ADD RISK SCENARIO</Button>
          </Link>
        )}

        {state === 'SCENARIOS_NO_CONTROLS' && (
          <Link to={`/risk-management`}>
            <Button primary>+ ADD CONTROLS</Button>
          </Link>
        )}

        {state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' && (
          <Link to={`/risk-assessments/${assessmentId}`}>
            <Button primary>+ ADD MODIFIERS</Button>
          </Link>
        )}
      </Div>
      <Spacer $px={20} />
    </>
  );
};
